
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ItinerarySelector } from '@/components/blog/ItinerarySelector';

interface BlogItinerariesTabProps {
  selectedItineraryIds: string[];
  onChange: (ids: string[]) => void;
}

export function BlogItinerariesTab({ selectedItineraryIds, onChange }: BlogItinerariesTabProps) {
  return (
    <Card className="glass-card">
      <CardHeader>
        <CardTitle>Linked Itineraries</CardTitle>
        <CardDescription>
          Connect this blog post to existing itineraries
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <ItinerarySelector 
          selectedItineraryIds={selectedItineraryIds}
          onChange={onChange}
        />
      </CardContent>
    </Card>
  );
}
